import React from 'react'
import { StaticQuery, graphql, Link } from 'gatsby'
import { StaticImage } from "gatsby-plugin-image"
import FormSearch from '../components/form_search'

class Header extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            showMobile: false,
            navChild: ''
        }
    }

    handleClick = e => {
        this.setState(prevState => ({
            showMobile: !prevState.showMobile
        }));
        //console.log(`Menu:`, this.state.showMobile);
    }

    handleNavChild = e => {
        e.preventDefault();
        let target = e.target.getAttribute('data-id');
        if (this.state.navChild === target) {
            this.setState({
                navChild: ''
            });
        } else {
            this.setState({
                navChild: target
            })
        }
        //console.log(`Child:`, this.state.navChild);
        //console.log(`Target:`, target);
    }

    render () {
        function getNav (allMarkdownRemarkGroup, nav) {
            let result = [];
            for (let edges of allMarkdownRemarkGroup) {
                for (let item of edges.edges) {
                    if (item.node.frontmatter.nav === nav) {
                        result.push(item.node)
                    }
                }
            }
            result.sort(function(a, b) {
                return a.frontmatter.nav_order - b.frontmatter.nav_order;
            });
            return result;
        }

        const NavSection = (p) => <ol>
            {p.navSectionItems.map( (p, i) => (<li key={i}><Link to={p.fields.slug}>{p.frontmatter.title}</Link></li>) )}
        </ol>

        const NavMobileSection = (p) => <ul className={this.state.navChild === `${p.navChild}` ? `show` : ``}>
        {p.navSectionItems.map( (p, i) => (<li key={i}><Link to={p.fields.slug}>&gt; {p.frontmatter.title}</Link></li>) )}
        </ul>

        return (
            <div>
                <header className="layout header yellow">
                    <div className="header__container">
                        <div className="header__flex flex__space-between">
                            <div className="logo">
                                <Link to="/" title="Forklift Solutions"><StaticImage src="../images/logo.png" alt="Forklift Solutions" style={{ display: "block" }} imgStyle={{ objectFit: "contain" }} /></Link>
                            </div>
                            <div className="phone">
                                <h3><a href="tel:0800653333" title="0800 653 343" rel="nofollow noopener">0800 653 343</a></h3>
                                <ul>
                                    <li>Experience</li>
                                    <li>|</li>
                                    <li>Safety</li>
                                    <li>|</li>
                                    <li>Innovation</li>
                                </ul>
                            </div>
                            <div className="nav__hamburger">
                                <button type="button" onClick={this.handleClick} id="nav-icon3" className={this.state.showMobile === true ? `open` : ``}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </header>

                <nav className="layout yellow mobile__off">
                    <div className="nav__container nav nav_flex_bottom">
                        <div className="nav_left">
                        <ul className="sf-menu">
                            <li><Link to="#" activeClassName="active" title="Products">Products</Link>
                                <ul>
                                    <ol>
                                        <li><Link to="/engine-counterbalance/" title="Engine Counterbalance">Engine Counterbalance</Link></li>
                                        <li><Link to="/electric-counterbalance/" title="Electric Counterbalance">Electric Counterbalance</Link></li>
                                        <li><Link to="/pedestrian/" title="Pedestrian">Pedestrian</Link></li>
                                        <li><Link to="/warehousing-electric/" title="Warehousing Electric">Warehousing Electric</Link></li>
                                        <li><Link to="/heavy-lift/" title="Heavy Lift">Heavy Lift</Link></li>
                                        <li><Link to="/used-forklifts/" title="Used Forklifts">Used Forklifts</Link></li>
                                    </ol>
                                </ul>
                            </li>
                            <li><Link to="#" activeClassName="active" title="Service">Service</Link>
                                <ul>
                                    <NavSection navSectionItems={getNav(this.props.data.group, 'service')} />
                                </ul>
                            </li>
                            <li><Link to="#" activeClassName="active" title="Solutions">Solutions</Link>
                                <ul>
                                    <NavSection navSectionItems={getNav(this.props.data.group, 'solutions')} />
                                </ul>
                            </li>
                            <li><a href="https://www.trainingsolutions.co.nz/w/" title="Training" target="_blank" rel="noopener nofollow noreferrer">Training</a></li>
                            <li><Link to="/booking/" activeClassName="active" title="Book Now">Book Now</Link></li>
                        </ul>
                        </div>
                        <div className="nav_right">
                            <FormSearch />
                        </div>
                    </div>
                </nav>
                <nav className={this.state.showMobile === true ? `layout yellow` : `layout yellow mobile_hide`}>
                    <div className="nav__mobile">
                        <ul>
                            <li><button type= "button" onClick={this.handleNavChild} data-id="child_1">&gt; Products</button>
                                <ul data-ul="child_1" className={this.state.navChild === `child_1` ? `` : `mobile_child_hide`}>
                                    <li>
                                        <ul>
                                            <li><Link to="/engine-counterbalance/" title="Engine Counterbalance">&gt; Engine Counterbalance</Link></li>
                                            <li><Link to="/electric-counterbalance/" title="Electric Counterbalance">&gt; Electric Counterbalance</Link></li>
                                            <li><Link to="/pedestrian/" title="Pedestrian">&gt; Pedestrian</Link></li>
                                            <li><Link to="/warehousing-electric/" title="Warehousing Electric">&gt; Warehousing Electric</Link></li>
                                            <li><Link to="/heavy-lift/" title="Heavy Lift">&gt; Heavy Lift</Link></li>
                                            <li><Link to="/used-forklifts/" title="Used Forklifts">&gt; Used Forklifts</Link></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li><button type= "button" onClick={this.handleNavChild} data-id="child_2">&gt; Service</button>
                                <ul data-ul="child_2" className={this.state.navChild === `child_2` ? `` : `mobile_child_hide`}>
                                    <li>
                                        <NavMobileSection navSectionItems={getNav(this.props.data.group, 'service')} />
                                    </li>
                                </ul>
                            </li>
                            <li><button type= "button" onClick={this.handleNavChild} data-id="child_3">&gt; Solutions</button>
                                <ul data-ul="child_3" className={this.state.navChild === `child_3` ? `` : `mobile_child_hide`}>
                                    <li>
                                        <NavMobileSection navSectionItems={getNav(this.props.data.group, 'solutions')} />
                                    </li>
                                </ul>
                            </li>
                            <li><Link to="/locations/" activeClassName="active" title="Locations">&gt; Locations</Link></li>
                            <li><a href="https://www.trainingsolutions.co.nz/w/" title="Training" target="_blank" rel="noopener nofollow noreferrer">&gt; Training</a></li>
                            <li><Link to="/booking/" activeClassName="active" title="Book Now">&gt; Book Now</Link></li>
                            <li><Link to="/contact-us/" activeClassName="active" title="Contact us">&gt; Contact Us</Link></li>
                        </ul>
                    </div>
                </nav>
            </div>
        )
    }
}

const HeaderNav = () => (
    <StaticQuery
        query={graphql`
            query {
                allMarkdownRemark {
                    group(field: frontmatter___nav) {
                        edges {
                            node {
                                fields {
                                    slug
                                }
                                frontmatter {
                                    title
                                    nav
                                    nav_order
                                }
                            }
                        }
                    }
                }
            }
        `}
        render={(data) => (
            <Header data={data.allMarkdownRemark} />
        )}
    />
)

export default HeaderNav;
